// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EntitySwitchController = function ($scope, $rootScope, $location, $http, $q, LegalEntity, SelectableLegalEntities, Permissions) {
    const pageSize = 20;
    const shiftLength = 12;
    $scope.parentEntity = null;
    $scope.nodes = {};
    
    if (!$scope.chosenEntityByUser) {
        $scope.chosenEntityByUser = $rootScope.chosenEntity;
    }

    $scope.loadEntities = function (options, callback) {
        return SelectableLegalEntities.query(options, function (data) {
            callback();

            // load children in case there is a single root legal entity
            if (data.length === 1 && data[0].IsRoot) {
                $scope.onViewSubEntities(data[0]);
            }
        });
    }

    $scope.onClick = function (chosenEntity) {
        $scope.chosenEntityByUser = chosenEntity;
    }

    $scope.cancel = function () {
        window.history.back();
    }

    $scope.onSelect = function () {
        LegalEntity.saveChosenEntity($scope.chosenEntityByUser);

        $http.defaults.headers.common["X-SELECTED-LEGAL-ENTITY-ID"] = $rootScope.chosenEntity.Id;

        $q.all([
            LegalEntity.reload(),
            Permissions.reload(),
        ]).then(function () {
            $location.path($rootScope.defaultLocation());
        });
    }
    
    $scope.onViewSubEntities = function(entity) {
        $scope.nodes[entity.Id] = entity;
        $scope.parentEntity = entity;

        $scope.applyFilter();
    }

    $scope.onBack = function() {
        if ($scope.parentEntity.ParentId) {
            $scope.parentEntity = $scope.nodes[$scope.parentEntity.ParentId];
        } else {
            $scope.parentEntity = null;
        }

        $scope.applyFilter();
    }

    $rootScope.getShift = function () {
        return " ".repeat(shiftLength);
    }

    $scope.clearFilter = function () {
        $scope.filter = "";
        $scope.applyFilter();
    }

    $scope.applyFilter = function () {
        const parentId = $scope.parentEntity ? $scope.parentEntity.Id : null;
        $scope.legalEntities = $scope.paginator(function (options, callback) {
            return $scope.loadEntities(options, callback);
        }, { search: $scope.filter, parentId, loadAllDescendants: false}, pageSize);
    };

    $scope.clearFilter();
};
EntitySwitchController.$inject = ['$scope', '$rootScope', '$location', '$http', '$q', 'LegalEntity', 'SelectableLegalEntities', 'Permissions'];
